import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/auth.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit(): void {
  }

  logout() {
    this.authService.logout();
    // this.modalService.open(this.logoutModal, {
    // 	centered: true,
    // 	windowClass: 'logout-modal modal-cls1',
    // }).result.then((result) => {
    // 	if (result == 'logout') {
    // 		this.authService.logout();
    // 	}
    // });
  }


}
